import styled, { css } from 'styled-components';
import { unit, pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { Typography } from '../../foundation/Typography/styled.js';

var CardHeaderTextContainer = styled.div.withConfig({
  displayName: "CardHeaderTextContainer",
  componentId: "sc-bd6cd9-0"
})(["display:flex;flex-direction:column;gap:", ";"], unit('sm'));
var CardFooterContainer = styled.div.withConfig({
  displayName: "CardFooterContainer",
  componentId: "sc-bd6cd9-1"
})(["box-sizing:border-box;flex:0 0 auto;display:flex;align-items:center;width:100%;padding:", " ", ";"], unit('lg'), unit('2xl'));
var CardContentContainer = styled.div.withConfig({
  displayName: "CardContentContainer",
  componentId: "sc-bd6cd9-2"
})(["padding:", ";height:100%;background-color:", ";"], function (_ref) {
  var $noPadding = _ref.$noPadding;
  return $noPadding ? 0 : "0 " + unit('2xl') + " " + unit('2xl');
}, themeGet('colors.background.50'));
var boxShadow = function boxShadow(token) {
  if (!token) {
    return undefined;
  }
  return css(["box-shadow:", ";"], themeGet("dropShadow." + token));
};
var cardBorder = function cardBorder(border) {
  if (border === void 0) {
    border = true;
  }
  if (!border) {
    return undefined;
  }
  return css(["border:", " solid ", ";"], pxToRem(1), themeGet('colors.border.100'));
};
var CardHeaderTitle = styled(Typography).withConfig({
  displayName: "CardHeaderTitle",
  componentId: "sc-bd6cd9-3"
})(["line-height:", ";font-weight:", ";font-size:", ";color:", ";"], themeGet('lineHeight.neutralized'), themeGet('fontWeight.medium'), themeGet('fontSize.large'), themeGet('color.300'));
var CardHeaderSubtitle = styled(Typography).withConfig({
  displayName: "CardHeaderSubtitle",
  componentId: "sc-bd6cd9-4"
})(["line-height:", ";font-weight:", ";font-size:", ";"], themeGet('lineHeight.neutralized'), themeGet('fontWeight.regular'), themeGet('fontSize.medium'));
var CardHeaderContainer = styled.div.withConfig({
  displayName: "CardHeaderContainer",
  componentId: "sc-bd6cd9-5"
})(["display:flex;flex-direction:column;width:100%;padding:", ";background-color:", ";"], unit('2xl'), themeGet('colors.background.50'));
var CardHeaderContent = styled.div.withConfig({
  displayName: "CardHeaderContent",
  componentId: "sc-bd6cd9-6"
})(["display:flex;flex-direction:row;gap:", ";align-items:center;"], unit('md'));
var smallSizeStyles = css(["", "{padding:", " ", ";}", "{font-size:", ";}", "{font-size:", ";}", "{padding:", ";}", "{padding:0 ", " ", ";}"], CardFooterContainer, unit('lg'), unit('xl'), CardHeaderTitle, themeGet('fontSize.medium'), CardHeaderSubtitle, themeGet('fontSize.small'), CardHeaderContainer, unit('xl'), CardContentContainer, unit('xl'), unit('xl'));
var CardContainer = styled.div.withConfig({
  displayName: "CardContainer",
  componentId: "sc-bd6cd9-7"
})(["display:flex;flex-direction:row;background-color:", ";border-radius:", ";overflow:hidden;color:", ";", ";", ";", ";"], themeGet('colors.gray.0'), themeGet('borderRadius.lg'), themeGet('color.200'), function (props) {
  return boxShadow(props.$dropShadow);
}, function (props) {
  return cardBorder(props.$border);
}, function (_ref2) {
  var _ref2$$size = _ref2.$size,
    $size = _ref2$$size === void 0 ? 'default' : _ref2$$size;
  return $size === 'small' ? smallSizeStyles : null;
});
var CardHeaderActionContainer = styled.div.withConfig({
  displayName: "CardHeaderActionContainer",
  componentId: "sc-bd6cd9-8"
})(["margin-left:auto;"]);
var CardFooterActionsContainer = styled.div.withConfig({
  displayName: "CardFooterActionsContainer",
  componentId: "sc-bd6cd9-9"
})(["display:flex;gap:", ";margin-left:auto;"], unit('xl'));
var CardMedia = styled.div.withConfig({
  displayName: "CardMedia",
  componentId: "sc-bd6cd9-10"
})(["flex:0 0 ", "%;background-color:", ";"], function (props) {
  return props.$fraction * 100;
}, themeGet('colors.primary.800'));
var CardBody = styled.div.withConfig({
  displayName: "CardBody",
  componentId: "sc-bd6cd9-11"
})(["display:flex;flex:1 1 auto;flex-direction:column;position:relative;min-width:0;"]);

export { CardBody, CardContainer, CardContentContainer, CardFooterActionsContainer, CardFooterContainer, CardHeaderActionContainer, CardHeaderContainer, CardHeaderContent, CardHeaderSubtitle, CardHeaderTextContainer, CardHeaderTitle, CardMedia };
